import { createAsyncTypes } from 'utils/ActionCreator'

export const CHANGE_INCIDENT_STATE_REQUEST_ASYNC = createAsyncTypes(
  'CHANGE_INCIDENT_STATE_REQUEST',
  'ResolutionCenter/AtoIncident'
)

export const TOGGLE_REMEDIATION_ACTION = 'ResolutionCenter/AtoIncident/TOGGLE_REMEDIATION_ACTION'

export const RESET_REMEDIATION_CONFIRMATION =
  'ResolutionCenter/AtoIncident/RESET_REMEDIATION_CONFIRMATION'

export const CHANGE_ASSIGNEES_ASYNC = createAsyncTypes(
  'CHANGE_ASSIGNEES',
  'ResolutionCenter/AtoIncident'
)

export const ACTIONS_LIST = {
  RESET_PASSWORD: 1,
  DISABLE_SIGNIN: 2,
  SIGN_OUT: 3,
}

export const REMEDIATION_ACTIONS_CONST = [
  // {
  //   type: ACTIONS_LIST.RESET_PASSWORD,
  //   text: 'Reset the account password (optional)',
  //   subtext: 'Reset their password via their phone or secondary email address.',
  //   confirmationText: 'Password has been reset',
  // },
  // {
  //   type: ACTIONS_LIST.DISABLE_SIGNIN,
  //   text: 'Disable sign-in access to the account',
  //   subtext: 'Locks an account, meaning employees cannot perform actions or log in at all, even with appropriate credentials. Account cannot be used until an administrator re-enables it.',
  //   confirmationText: 'Sign-in was disabled',
  // },
  {
    type: ACTIONS_LIST.SIGN_OUT,
    text: 'Sign out of all active existing sessions',
    subtext:
      'Signs out employees of any logged-in sessions which prevents an attacker who is logged in from performing any dangerous actions.',
    confirmationText:
      'All active sessions were closed. It might take several minutes for the change to be reflected in your system',
  },
]
